import { minWidth, maxWidth } from './respondTo';

export default {
  minWidth,
  maxWidth,
};
